"use strict";
/**
 * Point d'entrée du package `@webforge-survey/shared`.
 *
 * NB : les re-exports utilisent le pattern `import puis export`, et non
 * `export ... from`, pour produire un CJS détectable par Rollup
 * (analyse statique de Vite build). Sinon tsc émet
 * `Object.defineProperty(exports, ...)` que Rollup ne voit pas.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.findItem = exports.buildPayload = exports.sanitizeAnswers = exports.evaluateSurvey = exports.ExpressionError = exports.extractVariables = exports.evaluateBool = exports.evaluate = void 0;
// Moteur d'expressions
const expr_1 = require("./engine/expr");
Object.defineProperty(exports, "evaluate", { enumerable: true, get: function () { return expr_1.evaluate; } });
Object.defineProperty(exports, "evaluateBool", { enumerable: true, get: function () { return expr_1.evaluateBool; } });
Object.defineProperty(exports, "extractVariables", { enumerable: true, get: function () { return expr_1.extractVariables; } });
Object.defineProperty(exports, "ExpressionError", { enumerable: true, get: function () { return expr_1.ExpressionError; } });
// Moteur d'évaluation de définition
const engine_1 = require("./engine/engine");
Object.defineProperty(exports, "evaluateSurvey", { enumerable: true, get: function () { return engine_1.evaluateSurvey; } });
Object.defineProperty(exports, "sanitizeAnswers", { enumerable: true, get: function () { return engine_1.sanitizeAnswers; } });
Object.defineProperty(exports, "buildPayload", { enumerable: true, get: function () { return engine_1.buildPayload; } });
Object.defineProperty(exports, "findItem", { enumerable: true, get: function () { return engine_1.findItem; } });
//# sourceMappingURL=index.js.map